/* MCR wishlist page: renders saved handles from window.MCR.wishlist as product cards. */
(function () {
  'use strict';
  if (customElements.get('mcr-wishlist-page')) return;

  var CACHE_PREFIX = 'mcr:wl:p:';
  var CACHE_TTL = 10 * 60 * 1000;
  var CONCURRENCY = 6;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var cfg = window.MCRConfig || {};
    var fmt = cfg.moneyFormat || '₹{{amount}}';
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents || 0;
    function fmtNum(n, dec, t, d) {
      var fixed = (n / 100).toFixed(dec);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t);
      return parts.join(d);
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var val;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': val = fmtNum(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = fmtNum(cents, 2, "'", '.'); break;
      default: val = fmtNum(cents, 2, ',', '.');
    }
    var out = fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
    var tmp = document.createElement('div');
    tmp.innerHTML = out;
    return tmp.textContent;
  }

  function cacheGet(h) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + h);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (Date.now() - obj.t > CACHE_TTL) return null;
      return obj.p;
    } catch (e) { return null; }
  }
  function cacheSet(h, p) {
    try { sessionStorage.setItem(CACHE_PREFIX + h, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchProduct(handle) {
    var cached = cacheGet(handle);
    if (cached) return Promise.resolve(cached);
    return fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var slim = {
          handle: p.handle,
          title: p.title,
          url: p.url,
          available: p.available,
          featured_image: p.featured_image,
          images: (p.images || []).slice(0, 2),
          options: p.options,
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, available: v.available, price: v.price, compare_at_price: v.compare_at_price, featured_image: v.featured_image && v.featured_image.src };
          }),
        };
        cacheSet(handle, slim);
        return slim;
      })
      .catch(function () { return { handle: handle, missing: true }; });
  }

  function pool(items, limit, fn) {
    var results = new Array(items.length);
    var i = 0;
    function next() {
      if (i >= items.length) return Promise.resolve();
      var idx = i++;
      return fn(items[idx]).then(function (r) { results[idx] = r; return next(); });
    }
    var runners = [];
    for (var k = 0; k < Math.min(limit, items.length); k++) runners.push(next());
    return Promise.all(runners).then(function () { return results; });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    try {
      var u = new URL(src);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) { return src; }
  }

  class McrWishlistPage extends HTMLElement {
    connectedCallback() {
      var s = this.querySelector('[data-mcr-wl-strings]');
      try { this.t = JSON.parse(s ? s.textContent : '{}'); } catch (e) { this.t = {}; }
      this.max = parseInt(this.dataset.max, 10) || 48;
      this.grid = this.querySelector('[data-mcr-wl-grid]');
      this.empty = this.querySelector('[data-mcr-wl-empty]');
      this.toolbar = this.querySelector('[data-mcr-wl-toolbar]');
      this.countEl = this.querySelector('[data-mcr-wl-count]');
      this.loading = this.querySelector('[data-mcr-wl-loading]');
      this.products = {};
      this.renderToken = 0;

      this.onChange = this.onChange.bind(this);
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onSelect.bind(this));

      var self = this;
      var start = function () {
        self.setupImport();
        self.render();
        document.addEventListener('mcr:wishlist:change', self.onChange);
        window.addEventListener('storage', self.onStorage = function (e) { if (e.key === 'mcr:wishlist:v1') self.render(); });
      };
      if (window.MCR && window.MCR.wishlist) start();
      else document.addEventListener('mcr:ready', start, { once: true });
    }

    disconnectedCallback() {
      document.removeEventListener('mcr:wishlist:change', this.onChange);
      if (this.onStorage) window.removeEventListener('storage', this.onStorage);
    }

    handles() { return window.MCR.wishlist.all().slice(0, this.max); }

    onChange() {
      if (this.suppress) return;
      this.render();
    }

    /* ---------- import from ?items= ---------- */
    setupImport() {
      var params = new URLSearchParams(location.search);
      var raw = params.get('items');
      var banner = this.querySelector('[data-mcr-wl-import]');
      if (!raw || !banner) return;
      var current = window.MCR.wishlist.all();
      var incoming = raw.split(',').map(function (h) { return h.trim().toLowerCase(); })
        .filter(function (h) { return /^[a-z0-9][a-z0-9\-_]*$/.test(h) && current.indexOf(h) === -1; })
        .slice(0, this.max);
      if (!incoming.length) return;
      banner.hidden = false;
      var c = banner.querySelector('[data-mcr-wl-import-count]');
      if (c) c.textContent = incoming.length;
      var clean = function () {
        banner.hidden = true;
        params.delete('items');
        var q = params.toString();
        history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
      };
      var self = this;
      banner.querySelector('[data-mcr-wl-import-accept]').addEventListener('click', function () {
        self.suppress = true;
        incoming.slice().reverse().forEach(function (h) { window.MCR.wishlist.add(h); });
        self.suppress = false;
        clean();
        self.render();
        window.MCR.toast(self.t.imported);
      });
      banner.querySelector('[data-mcr-wl-import-dismiss]').addEventListener('click', clean);
    }

    /* ---------- render ---------- */
    render() {
      var handles = this.handles();
      var token = ++this.renderToken;
      var self = this;
      this.updateCount(handles.length);
      if (!handles.length) {
        this.grid.innerHTML = '';
        this.setEmpty(true);
        return;
      }
      this.setEmpty(false);
      // Drop cards no longer in the list
      Array.prototype.forEach.call(this.grid.querySelectorAll('[data-handle]'), function (li) {
        if (handles.indexOf(li.dataset.handle) === -1) li.remove();
      });
      var missing = handles.filter(function (h) { return !self.products[h]; });
      if (missing.length && !this.grid.children.length) this.loading.hidden = false;
      pool(missing, CONCURRENCY, fetchProduct).then(function (list) {
        if (token !== self.renderToken) return;
        list.forEach(function (p) { if (p) self.products[p.handle] = p; });
        self.loading.hidden = true;
        var frag = document.createDocumentFragment();
        handles.forEach(function (h, i) {
          var existing = self.grid.querySelector('[data-handle="' + CSS.escape(h) + '"]');
          if (existing) { frag.appendChild(existing); return; }
          var li = self.card(self.products[h] || { handle: h, missing: true }, i);
          frag.appendChild(li);
        });
        self.grid.appendChild(frag);
        if (window.MCR.init) window.MCR.init(self.grid);
      });
    }

    setEmpty(isEmpty) {
      this.empty.hidden = !isEmpty;
      this.toolbar.hidden = isEmpty;
      this.grid.hidden = isEmpty;
      if (isEmpty) this.loading.hidden = true;
      if (isEmpty && window.MCR.reveal) window.MCR.reveal(this.empty);
    }

    updateCount(n) {
      if (!this.countEl) return;
      this.countEl.textContent = (this.t.count || '[count]').replace('[count]', n);
    }

    variantFor(li) {
      var p = this.products[li.dataset.handle];
      if (!p || p.missing) return null;
      var sel = li.querySelector('select');
      var id = sel ? parseInt(sel.value, 10) : null;
      var v = p.variants.filter(function (x) { return id ? x.id === id : x.available; })[0];
      return v || null;
    }

    card(p, i) {
      var li = document.createElement('li');
      li.className = 'mcr-wl-card' + (this.dataset.cardScheme ? ' color-' + this.dataset.cardScheme : '');
      li.dataset.handle = p.handle;
      li.style.setProperty('--mcr-i', i % 8);
      li.setAttribute('data-mcr-reveal', 'fade-up');
      var t = this.t;
      var removeBtn =
        '<button type="button" class="mcr-wl-card__remove" data-mcr-wl-remove aria-label="' + esc(t.remove + ': ' + (p.title || p.handle)) + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
      if (p.missing) {
        li.classList.add('is-missing');
        li.innerHTML = '<div class="mcr-wl-card__media mcr-wl-card__media--empty"></div><div class="mcr-wl-card__body"><p class="mcr-wl-card__title">' +
          esc(p.handle.replace(/-/g, ' ')) + '</p><p class="mcr-wl-card__note">' + esc(t.unavailable) + '</p></div>' + removeBtn;
        return li;
      }
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var img2 = p.images && p.images[1];
      var srcset = [360, 540, 720].map(function (w) { return imgUrl(img, w) + ' ' + w + 'w'; }).join(', ');
      var media = img
        ? '<img src="' + esc(imgUrl(img, 540)) + '" srcset="' + esc(srcset) + '" sizes="(min-width: 990px) 25vw, 50vw" width="540" height="720" loading="lazy" alt="' + esc(p.title) + '">' +
          (img2 ? '<img class="mcr-wl-card__img2" src="' + esc(imgUrl(img2, 540)) + '" width="540" height="720" loading="lazy" alt="" aria-hidden="true">' : '')
        : '';
      var select = '';
      if (p.variants.length > 1) {
        var opts = p.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (v.id === first.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
            esc(v.title) + (v.available ? '' : ' — ' + esc(t.soldOut)) + '</option>';
        }).join('');
        var label = (p.options && p.options.length === 1 && p.options[0].name) || t.sizeLabel;
        var sid = 'mcr-wl-v-' + p.handle;
        select = '<div class="mcr-wl-card__select"><label for="' + esc(sid) + '">' + esc(label) + '</label>' +
          '<div class="mcr-wl-card__select-wrap"><select id="' + esc(sid) + '" name="id" autocomplete="off">' + opts + '</select>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></div></div>';
      }
      li.innerHTML =
        '<a class="mcr-wl-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
        removeBtn +
        '<div class="mcr-wl-card__body">' +
        '<h3 class="mcr-wl-card__title"><a class="mcr-link" href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
        '<p class="mcr-wl-card__price" data-mcr-wl-price>' + this.priceHtml(first) + '</p>' +
        select +
        '<button type="button" class="mcr-btn mcr-btn--red mcr-wl-card__add" data-mcr-wl-add aria-label="' + esc((first.available ? t.addToCart : t.soldOut) + ': ' + p.title) + '"' + (first.available ? '' : ' disabled') + '>' +
        '<span>' + esc(first.available ? t.addToCart : t.soldOut) + '</span></button>' +
        '</div>';
      return li;
    }

    priceHtml(v) {
      if (!v) return '';
      var html = '<span class="mcr-wl-card__now">' + esc(formatMoney(v.price)) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var off = Math.round((1 - v.price / v.compare_at_price) * 100);
        html += ' <s class="mcr-wl-card__was">' + esc(formatMoney(v.compare_at_price)) + '</s> <span class="mcr-wl-card__off">-' + off + '%</span>';
      }
      return html;
    }

    onSelect(e) {
      var sel = e.target.closest('select');
      if (!sel) return;
      var li = sel.closest('[data-handle]');
      var v = this.variantFor(li);
      li.querySelector('[data-mcr-wl-price]').innerHTML = this.priceHtml(v);
      var btn = li.querySelector('[data-mcr-wl-add]');
      btn.disabled = !(v && v.available);
      btn.querySelector('span').textContent = v && v.available ? this.t.addToCart : this.t.soldOut;
      var title = this.products[li.dataset.handle].title;
      btn.setAttribute('aria-label', (v && v.available ? this.t.addToCart : this.t.soldOut) + ': ' + title);
    }

    onClick(e) {
      var rm = e.target.closest('[data-mcr-wl-remove]');
      if (rm) return this.remove(rm.closest('[data-handle]'));
      var add = e.target.closest('[data-mcr-wl-add]');
      if (add) {
        var li = add.closest('[data-handle]');
        var v = this.variantFor(li);
        if (v) this.addToCart([{ id: v.id, quantity: 1 }], add);
        return;
      }
      if (e.target.closest('[data-mcr-wl-move-all]')) return this.moveAll(e.target.closest('button'));
      if (e.target.closest('[data-mcr-wl-share]')) return this.share();
    }

    remove(li) {
      if (!li) return;
      var handle = li.dataset.handle;
      var self = this;
      var done = function () {
        self.suppress = true;
        window.MCR.wishlist.remove(handle);
        self.suppress = false;
        li.remove();
        var left = self.handles();
        self.updateCount(left.length);
        if (!left.length) self.setEmpty(true);
      };
      if (reduceMotion) return done();
      li.classList.add('is-removing');
      var fired = false;
      var finish = function () { if (fired) return; fired = true; done(); };
      li.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 500);
    }

    moveAll(btn) {
      var self = this;
      var items = [];
      Array.prototype.forEach.call(this.grid.querySelectorAll('[data-handle]'), function (li) {
        var v = self.variantFor(li);
        if (v && v.available) items.push({ id: v.id, quantity: 1 });
      });
      if (!items.length) return window.MCR.toast(this.t.error);
      this.addToCart(items, btn, true);
    }

    addToCart(items, btn, all) {
      var self = this;
      var drawer = document.querySelector('cart-drawer');
      var notification = document.querySelector('cart-notification');
      var sectionIds = ['cart-icon-bubble'];
      var renderer = null;
      if (drawer && typeof drawer.renderContents === 'function') {
        renderer = drawer;
      } else if (notification && typeof notification.renderContents === 'function' && items.length === 1) {
        renderer = notification;
      }
      if (renderer && typeof renderer.getSectionsToRender === 'function') {
        sectionIds = renderer.getSectionsToRender().map(function (s) { return s.id; });
      }
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sectionIds.join(','), sections_url: window.location.pathname }),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            window.MCR.toast(res.description || res.message || self.t.error);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, { source: 'mcr-wishlist', productVariantId: items[0].id, errors: res.errors || res.description, message: res.message });
            }
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mcr-wishlist', productVariantId: items[0].id, cartData: res });
          }
          if (renderer) {
            var state = res;
            if (renderer === notification && res.items && res.items[0]) {
              state = Object.assign({}, res.items[0], { sections: res.sections });
            }
            try { renderer.renderContents(state); } catch (err) { self.refreshBubble(res.sections); }
            if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else {
            self.refreshBubble(res.sections);
          }
          window.MCR.toast(all ? self.t.addedAll : self.t.added);
        })
        .catch(function () { window.MCR.toast(self.t.error); })
        .finally(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
        });
    }

    refreshBubble(sections) {
      var el = document.getElementById('cart-icon-bubble');
      if (!el || !sections || !sections['cart-icon-bubble']) return;
      var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var src = doc.querySelector('.shopify-section');
      if (src) el.innerHTML = src.innerHTML;
    }

    share() {
      var handles = this.handles();
      if (!handles.length) return;
      var url = location.origin + location.pathname + '?items=' + handles.map(encodeURIComponent).join(',');
      var t = this.t;
      if (navigator.share) {
        navigator.share({ title: t.shareTitle, url: url }).catch(function () {});
        return;
      }
      var copied = function () { window.MCR.toast(t.copied); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(copied, function () { window.prompt(t.shareTitle, url); });
      } else {
        window.prompt(t.shareTitle, url);
      }
    }
  }

  customElements.define('mcr-wishlist-page', McrWishlistPage);
})();
